import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-reoccuring-otp",
    templateUrl: "./reoccuring-otp.component.html",
    styleUrls: ["./reoccuring-otp.component.scss"],
    standalone: false
})
export class ReoccuringOtpComponent implements OnInit {
  disableBtn: boolean;
  @Input() providerResponse: any;

  @Output() emitOTP = new EventEmitter();
  otpValues: string;

  @Output() emitResendOtp = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  digitValidate(ele) {
    ele.value = ele.target.value.replace(/[^0-9]/g, "");
  }

  tabChange(val) {
    let ele = document.querySelectorAll("input");

    // hadnle next input focus
    if (ele[val - 1].value != "" && ele[val]) {
      ele[val].focus();
    }

    // handle prev input focus
    if (ele[val - 1].value == "" && ele[val - 2]) {
      ele[val - 2].focus();
    }
  }

  sendOTP() {
    let otpValues = "";
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      otpValues += input.value;
    });
    this.otpValues = otpValues;

    this.emitOTP.emit(otpValues);
  }

  resendOTP() {
    this.emitResendOtp.emit();
  }
}
